exports.components = {
  "component---src-image-template-js": () => import("./../../../src/image-template.js" /* webpackChunkName: "component---src-image-template-js" */),
  "component---src-index-template-js": () => import("./../../../src/index-template.js" /* webpackChunkName: "component---src-index-template-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

